import moment from 'moment'

// Source: http://aboutcode.net/2013/07/27/json-date-parsing-angularjs.html#comment-2572707274
// eslint-disable-next-line no-useless-escape
const regexIso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

export function convertDateStringsToDates(input) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (const key in input) {
        if (!Object.prototype.hasOwnProperty.call(input, key)) continue;

        const value = input[key];
        let match;
        // Check for string properties which look like dates.
        // The regex identifies 4-digit numbers as dates, so explicitly reject it in this case.
        if (typeof value === "string" && !/^\d+$/.test(value) && (match = value.match(regexIso8601))) {
            const momentDate = parseDateString(match[0]);
            input[key] = momentDate.toDate();
            // Allow the moment date to be accessed directly, in order to allow data not supported by JS dates
            // to be accessed (eg, DateTimeOffset)
            input.__moment = input.__moment || {};
            input.__moment[key] = momentDate;
        } else if (typeof value === "object") {
            // Recurse into object
            convertDateStringsToDates(value);
        }
    }
    return input
}

function parseDateString(dateString) {
    // Use moment to parse ISO 8601 strings
    const momentDate = moment(dateString);
    if (momentDate.isValid()) {
        return momentDate;
    }
    // Fall back to Date.parse. In most cases this shouldn't be used since Apex API uses ISO 8601 format.
    // Note: date.js overrides the parse method for cross-browser consistency and can be fairly slow.
    const milliseconds = Date.parse(dateString)
    if (milliseconds !== null && !isNaN(milliseconds)) {
        return moment(new Date(milliseconds));
    }
    // Just try to wrap it in a date object anyway. Eg, yyyy-MM-ddThh:mm:ss.sssZ doesn't work with Date.parse for some reason.
    return moment(new Date(dateString));
}
